var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.domVisible,
        "custom-class": _vm.dialogClass,
        "close-on-click-modal": false,
        "lock-scroll": false,
        "before-close": _vm.closeDialog
      },
      on: {
        "update:visible": function($event) {
          _vm.domVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen",
              value: _vm.loading,
              expression: "loading",
              modifiers: { fullscreen: true }
            }
          ]
        },
        [
          _c("el-scrollbar", [
            _vm.list != null
              ? _c("div", { staticClass: "setAddressList" }, [
                  _c(
                    "ul",
                    _vm._l(_vm.list, function(item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          class: _vm.newadd == index ? "on" : "",
                          on: {
                            click: function($event) {
                              return _vm.setOnlyAddress(index, item)
                            }
                          }
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "addressName" }, [
                              _vm._v(
                                _vm._s(item.City) +
                                  " (" +
                                  _vm._s(item.UserName) +
                                  _vm._s(
                                    _vm.$i18n.locale === "zh" ? "收" : ""
                                  ) +
                                  ")"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "addressText line_txt2" },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("setProvice")(item.Provice)) +
                                    " " +
                                    _vm._s(item.AddressDetail)
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "addressPhone" }, [
                              _vm._v(_vm._s(item.Email))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "addressPhone" }, [
                              _vm._v(_vm._s(item.Mobile))
                            ])
                          ]),
                          _vm._v(" "),
                          item.IsDefault
                            ? _c("span", { staticClass: "default" }, [
                                _vm._v(_vm._s(_vm.$t("MakePrimary")))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "setAddress",
                              on: {
                                click: function($event) {
                                  return _vm.setAddress("address", 1, item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Edit")))]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "setaddressnew" }, [
            _c(
              "div",
              {
                staticClass: "setinfo",
                on: {
                  click: function($event) {
                    return _vm.setAddress("address", 0)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("AddNewAddress")))]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "setaddressbtn" },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.disabled, type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Save")))]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v(_vm._s(_vm.$t("Cancel")))
              ])
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72b0bfce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72b0bfce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/setaddress.vue
// module id = null
// module chunks = 